import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormFooterDirective } from './form-footer.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FormFooterDirective
  ],
  exports: [
    FormFooterDirective
  ]
})
export class FormFooterModule { }
